<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Product Lead Time Analysis</b-card-title>
      </b-card-header>
      <apexchart
        type="line"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "LeadTimeAnalysisChart",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  data() {
    return {
      series: [
        {
          name: "Lead Time",
          data: [5, 12, 8, 20, 15, 7, 10, 5] // Example lead time values in days
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "line", // Line chart for plotting lead time
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth', // Smooth lines for better readability
          width: 2
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        xaxis: {
          type: 'datetime', // Use datetime for the x-axis
          categories: [
            '2025-01-01', '2025-01-05', '2025-01-10', '2025-01-15', 
            '2025-01-20', '2025-01-25', '2025-01-30', '2025-02-04' // Dates for each data point
          ],
          title: {
            text: 'Date'
          }
        },
        yaxis: {
          title: {
            text: 'Lead Time (Days)'
          }
        },
        fill: {
          colors: ['#4e73df'], // Blue color for the line
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy', // Format the tooltip for date
          },
          y: {
            formatter: function (val) {
              return val + ' days'; // Display lead time in days
            }
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
        }
      }
    };
  }
};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>
